export const DOCUMENT_AI_BATCH_JOB_IDS_STORAGE_KEY = 'demoDocumentAiBatchJobId';

export const migrateLegacyStoredBatchJobIds = (raw: string | null | undefined): string[] => {
  const s = String(raw ?? '').trim();
  if (!s) return [];
  if (s.startsWith('[')) {
    try {
      const parsed = JSON.parse(s) as unknown;
      if (Array.isArray(parsed)) {
        return [...new Set(parsed.map((x) => String(x ?? '').trim()).filter(Boolean))];
      }
    } catch {
      return [];
    }
  }
  return [s];
};

export const readStoredBatchJobIds = (): string[] => {
  if (typeof window === 'undefined') return [];
  try {
    const v = window.localStorage.getItem(DOCUMENT_AI_BATCH_JOB_IDS_STORAGE_KEY);
    return migrateLegacyStoredBatchJobIds(v);
  } catch {
    return [];
  }
};

export const writeStoredBatchJobIds = (ids: string[]) => {
  if (typeof window === 'undefined') return;
  try {
    const unique = [...new Set(ids.map((x) => String(x ?? '').trim()).filter(Boolean))];
    window.localStorage.setItem(DOCUMENT_AI_BATCH_JOB_IDS_STORAGE_KEY, JSON.stringify(unique));
  } catch {
    // ignore
  }
};

export const removeStoredBatchJobId = (jobId: string) => {
  const id = String(jobId ?? '').trim();
  if (!id) return;
  const prev = readStoredBatchJobIds();
  writeStoredBatchJobIds(prev.filter((x) => x !== id));
};
